export enum DataSourceIdTypes {
  HHID = "hhid",
  NBCUSyntheticID = "nbcuSyntheticId",
  ViacomSyntheticID = "viacomSyntheticId",
  BlockgraphId = "blockgraphId"
}
